import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class HubSpotUser extends BaseEntityModel {
  id?: number;
  userId?: number;
  hubspotId?: string;
  canBeAssigned?: boolean;
  type?: string;

  constructor(model: Partial<HubSpotUser> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.hubspotId = model.hubspotId;
    this.canBeAssigned = model.canBeAssigned;
    this.type = model.type;
  }
}
